import * as React from 'react';
import { jsx, css } from '@emotion/react';
import type { BaseAnswerType } from '../../views/types';
import type { SectionsPropsType } from '../types';
import { renderAdvisorMessage } from '../../views/AdvisorMessage';
import { renderSingleImage } from '../../views/SingleImage';
import { renderSimpleButtonGroup } from '../../views/SimpleButtonGroup';
import { buildAnswers } from '../utils';

import KaeruPleaseGifPath from 'Images/me/pages/guest/proposals/new/region/kaeru_please.gif'

const SECTION_KEY_NAME = 'region';
const PARAM_NAME = SECTION_KEY_NAME;
const GA_EVENT_NAME = 'region';

export const regionSection = async (props: SectionsPropsType) => {
  const { userAnswers, commonAnswerHandler } = props;
  const answers: BaseAnswerType[] = [
    { value: '北海道・東北' },
    { value: '関東' },
    { value: '北陸・甲信越' },
    { value: '東海' },
    { value: '関西' },
    { value: '中国' },
    { value: '四国' },
    { value: '九州・沖縄' },
  ];
  const answerHandler = (event: React.MouseEvent<HTMLButtonElement>): void => {
    const { textContent, value } = event.currentTarget;

    commonAnswerHandler(PARAM_NAME, textContent || '');

    userAnswers.push({
      keyName: SECTION_KEY_NAME,
      paramName: PARAM_NAME,
      question: '地域は',
      answer: textContent || '',
      value: value || '',
    });
  };

  // アドバイザーの吹き出し
  await renderAdvisorMessage({
    ...props,
    keyName: SECTION_KEY_NAME,
    doesNotScroll: true,
    messageElement: (
      <>
        物件の場所は、どちらになりますか？
      </>
    ),
  });

  await renderSingleImage({
    ...props,
    keyName: SECTION_KEY_NAME,
    doesNotScroll: true,
    imagePaths: {
      imagePath: KaeruPleaseGifPath,
    },
    altText: 'お願いします！',
    viewWidth: {
      pc: 236,
      mobile: 180,
    },
    imageRatio: { width: 236, height: 198 },
    delayTime: 1,
  });

  // 回答ボタン表示
  const answer = await renderSimpleButtonGroup({
    ...props,
    keyName: SECTION_KEY_NAME,
    enableHideAnimation: false,
    answers: buildAnswers({
      keyName: SECTION_KEY_NAME,
      answers,
      answerHandler,
      gaEventName: GA_EVENT_NAME,
    }),
  });

  // 回答内容を返却する
  return answer;
};
